import { createAsyncAction } from 'typesafe-actions';
import { NotificationRuleGlossary } from '@rootCommon/types/glossary';

export const fetchNotificationRulesGlossary = createAsyncAction(
  'FETCH_NOTIFICATION_RULES_GLOSSARY_REQUEST',
  'FETCH_NOTIFICATION_RULES_GLOSSARY_SUCCESS',
  'FETCH_NOTIFICATION_RULES_GLOSSARY_FAILURE',
)<undefined, NotificationRuleGlossary[], Error>();

export default fetchNotificationRulesGlossary;
